module.exports = __webpack_public_path__ + "img/purple-header-ar.d428c68c.png";